import Description from './component';

export default Description;
